var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm._m(0);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "layout-default"
  }, [_c('h2', {
    staticClass: "h3 mb-25"
  }, [_vm._v("\n    О магазине\n  ")]), _vm._v(" "), _c('h3', {
    staticClass: "h5 mb-8"
  }, [_vm._v("\n    Магазин электроники 05.ru\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "p mb-8"
  }, [_vm._v("\n    05.ru - сеть магазинов электроники и бытовой техники. На сегодняшний день компания насчитывает 8 филиалов в республике Дагестан (в Махачкале, Хасавюрте, Дербенте и Избербаше). Интернет-магазин 05.ru осуществляет доставку по всей России. Колл-центр\n    компании работает 7 дней в неделю и оказывает всестороннюю поддержку покупателям.\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "p mb-8"
  }, [_vm._v("\n    Мы предлагаем широчайший ассортимент товаров, сервисов и услуг. Покупателям представлено более 15 000 наименований компьютерной,\n    мелкой и крупной бытовой, аудио/видео, цифровой и климатической техники, медиа товаров, аксессуаров, инструментов, посуды, мебели и\n    других товаров для дома.\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "p mb-8"
  }, [_vm._v("\n    Компания 05.ru начала свое существование в далеком 2003 году и специализировалась на продаже компьютерной техники. Со временем\n    ассортимент расширялся, спрос нарастал, доверие клиентов укреплялось. В 2017 году открылся филиал в Дербенте, в 2018 - в Хасавюрте, в\n    2019 - гипермаркеты в этих двух городах и еще один магазин в Махачкале.\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("\n    Сегодня компания 05.ru - большая команда, сплоченная общими целями, корпоративными ценностями и принципами. Наша цель - помочь\n    клиентам сделать быт комфортным, а работу более эффективной с помощью новейших технологий и качественного сервиса. Забота о Клиенте\n    является приоритетным направлением нашей деятельности: именно для него мы улучшаем сервис, становимся ближе и доступнее.\n  ")]), _vm._v(" "), _c('h3', {
    staticClass: "h5 mt-19 mb-8"
  }, [_vm._v("\n    Партнёры:\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "p mb-8"
  }, [_vm._v("\n    Партнером является OOO AT поддерживающее и разрабатывающее мобильное программное обеспечения для компании 05.ru. Основным видом\n    деятельности компании является разработка мобильного программного обеспечения.\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("\n    ООО AT зарегистрирована по адресу г. Москва, п. Сосенское, п. Коммунарка, ул. Липовый парк, д. 11, кв. 297, 108814. Генеральный\n    директор организации ОБЩЕСТВО С ОГРАНИЧЕННОЙ ОТВЕТСТВЕННОСТЬЮ \"АЙТИ ТЕХНОЛОГИИ\" Магомедова Назира Магомедовна. Телефонный номер: +7\n    (918) 733-19-97\n  ")])]);
}]

export { render, staticRenderFns }